import React, { useContext } from "react";


import Footer from "./footer";
import { Link } from 'react-router-dom';
import ItrPricingPlan from "./Itrpricingplan";
import { useState,useEffect } from 'react';
import Testimonial from "./Testimonial";
import HomeCounters from "./Homecounters";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";


function Itrfiling() {

    
const [itrPlans, setItrPlans] = useState([]);

useEffect(() => {
  const loadItrPlans = async () => {
    try {
      const response = await http.get("/service-plans", {
        params: { service_id: 16 }
      });

      if (response.data.success) {
        setItrPlans(response.data.plans);
      }
    } catch (error) {
      console.log(error);
    }
  };

  loadItrPlans();
}, []);

const startingPrice = itrPlans.find(
  (plan) => plan.sort_order === 1
)?.price; 



    const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
 
    const toggleQuestion = (questionId) => {
        setActiveQuestion((prev) => (prev === questionId ? null : questionId));
    };







    const [isChecked, setIsChecked] = useState(true);

    const handleToggleChange = () => {
        setIsChecked(!isChecked);
    };

    const tenures = [
        {
            label: "1 Year",

            price: "751.00",
            yearlyPrice: "1502.00",
            savings: "Save 50%",
        },
        {
            label: "2 Years",
            price: "1500.00",
            yearlyPrice: "3000.00",
            savings: "Save 50%",
        },
    ];
    const features = [
        'Salaried Income',
        '(Form-16 or Other)',
        'Business Income - Trading',
        'Business Income - Service Provider',
        '(Esitmated Turnover and Profit)',
       
  
        'Documents sharing facility',
       
        'Password sharing',
        'Round the clock support',
        'Time to time updates & notifications',
        'Time to time advice and support'
    ];

    const features1 = [
        ' Salaried Income + Shares Transactions',
       
        'Salaried Income + Property Sold',
        '(Form-16 or Other)',
        'Salaried Income + Business Income',
        '(Esitmated Turnover and Profit)',

       
        'Documents sharing facility',
       
        'Password sharing',
        'Round the clock support',
        'Time to time updates & notifications',
         'Time to time advice and support'
    ];

    //   const inclusions = [
    //     'E-way bill facility',
    //     'Documents sharing facility',
    //     'Mobile application support',
    //     'Download deliverables anytime',
    //   ];

    const tenures1 = [
        {
            value: '4 Years',
            label: '1 Year',
            price: '1251.00',
            yearlyPrice: '2502.00',
            savings: 'Save 50%',
        },
        {
            value: '5 Years',
            label: '2 Year',
            price: '1951.00',
            yearlyPrice: '4336.00',
            savings: 'Save 50% + 10%',
        },
    ];
    const features3 = [
        ' Business Income + Shares Transactions',
        'Business Income + Property Sold',
        'Business Income + Salaried Income',
        '(Esitmated Turnover and Profit)',
        
      
        'Documents sharing facility',
  
        'Password sharing',
        'Round the clock support',
        'Time to time updates & notifications',
        ' Time to time advice and support'
    ];

    //   const inclusions2 = [
    //     'E-way bill facility',
    //     'Documents sharing facility',
    //     'Mobile application support',
    //     'Download deliverables anytime',
    //   ];

    const tenures3 = [
        {
            value: '4 Years',
            label: '1 Year',
            price: '2351.00',
            yearlyPrice: '4702.00',
            savings: 'Save 50%',
        },
        {
            value: '5 Years',
            label: '2 Year',
            price: '3851.00',
            yearlyPrice: '8500.00',
            savings: 'Save 50% + 10%',
        },
    ];

    const tenures2 = [
        {
            value: '4 Years',
            label: '1 Year',
            price: '1351.00',
            yearlyPrice: '2702.00',
            savings: 'Save 50%',
        },
        {
            value: '5 Years',
            label: '2 Year',
            price: '2051.00',
            yearlyPrice: '4500.00',
            savings: 'Save 50% + 10%',
        },
    ];

    const features2 = [
        'Salaried Income with Arrear',
        '(Form 16 Govt. Employee)',
        'Business Income',
        '(Balance Sheet Preparation with FD,Loan,Investment,Property and Detailed Business Transaction)',
        'Partnership Firm, LLP, Company, Society, Trust ITR',
      
        'Documents sharing facility',
        
        'Password sharing',
        'Round the clock support',
        'Time to time updates & notifications',
        'Time to time advice and support',
    ];
    const tenures4 = [
        {
            label: "1 Year",

            price: "751.00",
            yearlyPrice: "1502.00",
            savings: "Save 50%",
        },
        {
            label: "2 Years",
            price: "1500.00",
            yearlyPrice: "3000.00",
            savings: "Save 50%",
        },
    ];
    const features4 = [
        "Estimated Income/Turnover (section 44AD/44ADA)",
        "Dashboard for managing service",
        "Mobile application support",
        "Documents sharing facility",
        "Download deliverables any time",
        "Password sharing",
        "Round the clock support",
        "Time to time updates & notifications",
    ];
    const tenures5 = [
        {
            value: '4 Years',
            label: '1 Year',
            price: '1351.00',
            yearlyPrice: '2702.00',
            savings: 'Save 50%',
        },
        {
            value: '5 Years',
            label: '2 Years',
            price: '2051.00',
            yearlyPrice: '4500.00',
            savings: 'Save 50% + 10%',
        },
    ];

    const features5 = [
        'Estimated Income/Turnover (section 44AD/44ADA)',
        'Bank Transaction view',
        'P&L and balance sheet preparation',
        'Dashboard for managing service',
        'Mobile application support',
        'Documents sharing facility',
        'Download deliverables any time',
        'Password sharing',
        'Round the clock support',
        'Time to time updates & notifications',
    ];
    const tenures6 = [
        {
            value: '4 Years',
            label: '1 Year',
            price: '1851.00',
            yearlyPrice: '3702.00',
            savings: 'Save 50%',
        },
        {
            value: '5 Years',
            label: '2 Years',
            price: '2851.00',
            yearlyPrice: '6335.00',
            savings: 'Save 50% + 10%',
        },
    ];

    const features6 = [
        'Estimated Income/Turnover (section 44AD/44ADA)',
        'Bank Transaction view',
        'P&L and balance sheet preparation',
        'Income from other than business or profession included',
        'Dashboard for managing service',
        'Mobile application support',
        'Documents sharing facility',
        'Download deliverables any time',
        'Password sharing',
        'Round the clock support',
        'Time to time updates & notifications'
    ];
    const tenures7 = [
        {
            value: '4 Years',
            label: '1 Year',
            price: '2351.00',
            yearlyPrice: '4702.00',
            savings: 'Save 50%',
        },
        {
            value: '5 Years',
            label: '2 Year',
            price: '2851.00',
            yearlyPrice: '6335.00',
            savings: 'Save 50% + 10%',
        },
    ];

    const features7 = [
        "Estimated Income/Turnover (section 44AD/44ADA)",
        "Bank Transaction view",
        "P&L and balance sheet preparation",
        "Income from other than business or profession included",
        "Filing through Balance Sheet",
        "Mobile application support",
        "Documents sharing facility",
        "Download deliverables any time",
        "Password sharing",
        "Round the clock support",
        "Time to time updates & notifications"
    ];
    const tenures8 = [
        {
            value: '4 Years',
            label: '1 Year',
            price: '2951.00',
            yearlyPrice: '5902.00',
            savings: 'Save 50%',
        },
        {
            value: '5 Years',
            label: '2 Year',
            price: '4751.00',
            yearlyPrice: '10500.00',
            savings: 'Save 50% + 10%',
        },
    ];

    const features8 = [
        'Estimated Income/Turnover (section 44AD/44ADA)',
        'Bank Transaction view',
        'P&L and balance sheet preparation',
        'Income from other than business or profession included',
        'Filing through Balance Sheet',
        'Filing through Audit Report',
        'Mobile application support',
        'Documents sharing facility',
        'Download deliverables any time',
        'Password sharing',
        'Round the clock support',
        'Time to time updates & notifications',
    ];



    const [receivedData, setReceivedData] = useState(null);

    const handleDataFromChild = (data) => {
        console.log("Data received from child:", data);
        setReceivedData(data);
    };



    const { services, loading, error } = useContext(ServicesContext);  
    if (loading) {
       return <div>Loading...</div>;  // Show loading state while fetching data
   }
 
   if (error) {
        return <div>{error}</div> // Show error state if there was an issue fetching data
   }
    const service = services.find(s => s.service_id === 16);
    
const handleBannerClick = () => {
   const element = document.querySelector(".price-heading");

   if (element) {
      const offset = 100; // header height
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
         top: elementPosition - offset,
         behavior: "smooth"
      });
   }
};
    return (
  <div>
   <div className="hero-section">
   <div className="container">
     <div className="row hero-row">
 
       <div className="col-lg-8 hero-left">
        <div class="title title2">
            
            <h1 class="sk-text-color">E-Filing Income Tax</h1>
 
        <p className="pdrl-text">
  Start with Only{" "}
  <span className="text-color">
    {startingPrice
      ? `₹${Number(startingPrice).toLocaleString("en-IN")}/-`
      : "Loading..."}
  </span>
</p>
                                <p className="pd-text">Effortlessly file tax returns for salary, capital gains, business, profession, or property income. Our comprehensive tax return services make the process seamless and hassle-free.</p>
 
              <div className="btn-group">
                                    <Link to="/contactus" className="theme-btn-3 btn-color ">
                                        Schedule A Call <span><i className="fa-solid fa-arrow-right"></i></span>
                                    </Link>
                </div>
                                <div className="space30"></div>
                               
         {/* <div className="hero-link">
           <a href="/gst-registration">Know more about GST & Registration</a>
         </div> */}
         <div className="banner" onClick={handleBannerClick}>
                            <img src="assets/icons/banner.svg" alt="" />
                         </div>
       </div>
  </div>
       <div className="col-lg-4 hero-right">
        <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" /> 
         <img src="assets/img/images/girl2.png" alt="GST Filing" />
       </div>
 
     </div>
   </div>
 </div>
 

            <div className="space60"></div>



            <div className="home4-counters bg-white">
                <div className="container">
                    <div className="row">
                        
                            <div className="col-md-12">


                                <HomeCounters />
                            </div>
                      

                    </div>

                    <div className="container ">
                        <div className="row">

                            <div className="col-lg-12">
                                <div className="hadding7">
                                    <div className="space60"></div>

                                    <h2 className="aos-init aos-animate text-center price-heading">Plans</h2>
                                </div>
                            </div>
                            <div className="col-12 text-center">

                                <div className={`plan-toggle-wrap ${isChecked ? 'active' : ''}`}>
                                    <div className="toggle-inner">
                                        <input
                                            id="ce-toggle"
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={handleToggleChange}
                                        />
                                        <span className="custom-toggle"></span>
                                        <div className="t-month">
                                            <h4>Salaried Person</h4>
                                        </div>
                                        <div className="t-year">
                                            <h4>Yearly <span>(20% Save)</span></h4>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>




                    <div className="space50"></div>
                    <div className="tab-content container ">
                        <div id="monthly " style={{ display: isChecked ? 'block' : 'none' }}>
                          <div className="row box-containerr">
  {itrPlans.map((plan) => (
    <div className="col-md-3 col-sm-6" key={plan.id}>
      <ItrPricingPlan
        title={plan.title}
        price={parseFloat(plan.price)}
        add={plan.meta?.add || 0}
        tenures={plan.meta?.tenures || []}
        features={plan.meta?.features || []}
        onSubmit={handleDataFromChild}
      />
    </div>
  ))}
</div>

                        </div>


                       





                    </div>
                </div>
<div className="container">
                <div id="yearly" style={{ display: isChecked ? 'none' : 'block' }}>
                            <div className="row box-containerr">
                                <div className="col-md-3 col-sm-6 ">

                                    <ItrPricingPlan
                                      price="625"
                                        title="Starter"
                                        tenures={tenures4}
                                        features={features4} onSubmit={handleDataFromChild}
                                    />
                                </div>

                                <div className="col-md-3 col-sm-6">

                                    <ItrPricingPlan
                                     price="1075"
                                        title="Basic"
                                        tenures={tenures5}
                                        features={features5} onSubmit={handleDataFromChild}
                                    />
                                </div>

                                <div className="col-md-3 col-sm-6">

                                    <ItrPricingPlan
                                      price="1075"
                                        title="Pro"
                                        tenures={tenures6}
                                        features={features6} onSubmit={handleDataFromChild}
                                    />
                                </div>


                          

                                <div className="col-md-3 col-sm-6">

                                    <ItrPricingPlan
                                      price="1075"
                                        title=" Premium"
                                        tenures={tenures8}
                                        features={features8} onSubmit={handleDataFromChild}
                                    />

                                </div>
                            </div>

                        </div>
                        </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">

                                <div className="space90"></div>
                                <h2 className="text-center">How to E-File Income Tax Returns  </h2>
                                <div className="space20"></div>
                                <img src="assets/img/images/legal251-how-to-apply.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="space40"></div>
                </div>


                <div className="space40 bg-white"></div>

                <div className="service-binifits9 sp0 bg-white"  >

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hadding7">

                                    <h2 className="text-center">Benefits of Using Dm2Legal for ITR E-Filing</h2>

                                    <div className="service-binifits-boxs">
                                        <div className="row">

                                            <div className="col-md-4">
                                                <div className="single-boxs bg-box">
                                                    &nbsp;&nbsp;<div className="icon">
                                                        <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                            Efficient Time Saving</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="single-boxs bg-box">
                                                    &nbsp;&nbsp;<div className="icon">
                                                        <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                            Comfort of Filing From Anywhere</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="single-boxs bg-box">
                                                    &nbsp;&nbsp;<div className="icon">
                                                        <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                            Simple, Easy and Faster Process</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="single-boxs bg-box">
                                                    &nbsp;&nbsp;<div className="icon">
                                                        <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                            Obtaining Valid Documentation</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="single-boxs bg-box">
                                                    &nbsp;&nbsp;<div className="icon">
                                                        <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                            Avoid Penalties</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="single-boxs bg-box">
                                                    &nbsp;&nbsp;<div className="icon">
                                                        <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                            Decreased complex process</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="single-boxs bg-box">
                                                    &nbsp;&nbsp;<div className="icon">
                                                        <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                            Post Purchase Service Support</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="single-boxs bg-box">
                                                    &nbsp;&nbsp;<div className="icon">
                                                        <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                            Best Virtual Assistance</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="single-boxs bg-box">
                                                    &nbsp;&nbsp;<div className="icon">
                                                        <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Secure & Confidential</p>
                                                    </div>

                                                </div>
                                            </div>



                                        </div>
                                    </div>



                                </div>

                            </div>
                            <div className="space30"></div>
                        </div>





                    </div>
                </div>
                <div className="space40"></div>


                <div className="service-binifits9 sp0 last-section" id="service2" >
                    <div className="space50"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hadding7">
                                    <h2 className="text-center">Income Tax Returns E-Filing for Individuals and Businesses</h2>
                                    <div className="space30"></div>
                                    <p className="pd-text"> Filing income tax is mandatory for both individuals and business owners. Tax eligibility depends on factors like age and gross annual income. To complete the process, taxpayers can file their Income Tax Return (ITR) using either the ITR-3 or ITR-4 form, based on their specific requirements.</p>
                                    <div className="space30"></div>
                                    <p className="pd-text">For ITR-4, income must be calculated using either the presumptive tax method or the traditional method. Filing an ITR allows you to track and document your taxes for the current year based on your income bracket, ensuring compliance and proper financial management.</p>
                                    <div className="space30"></div>
                                    <p className="pd-text">All businesses and companies must file income tax returns, even if they incur a loss. However, self-employed individuals are exempt if they have no taxable income for that year. Late filing fees apply to both individuals and businesses, emphasizing the importance of timely compliance.</p>
                                    <div className="space30"></div>
                                    <p className="pd-text">E-filing provides taxpayers with speed, security, convenience, and time savings. It also reduces the workload on the income tax department by offering a streamlined alternative to traditional paper filing.</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="contact6-list doc-list">

                                    <ul>
                                        <div className="space30"></div>
                                        <p className="pd-text">Here are some important points related to ITR E-filing for Individuals and Businesses:</p>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Saves time</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Hassle-free process</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>A good alternative to traditional ITR filing</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>User-friendly interface</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Easy verification process</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Real-time tracking facility</li>


                                    </ul>
                                </div>

                            </div>

                            <div className="col-lg-5">

                                <div className="contact6-list doc-list">
                                    <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                                </div>


                            </div>
                            <div className="space30"></div>
                        </div>



                    </div>
                </div>




                <div className="bg-white">

                    <div className="container ">

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hadding7">
                                    <div className="space40"></div>
                                    <h2 className="text-center">Documents Required for ITR E-Filing</h2>
                                    <div className="space30"></div>


                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="single-price border-none">
                                
                                    <div className="price-body">
                                  

                                        <ul>
                                            
                                        <h3 className="pd-text">Common Documents:</h3>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN card</li>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhaar card</li>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Previous year Balance sheet / Audit report (if any)</li>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statements / Bank passbook</li>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Any Income / Deduction doucments (if any)</li>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Previous year return (if any)</li>
                                        </ul>
                                        <div className="space20"></div>


                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="single-price border-none">

                                    <div className="price-body">
                                        <ul>

                                            <h3 className="pd-text">If you are:</h3>
                                            <div className="sapce30"></div>
                                            <p className="pd-text">Salaried</p>
                                            <ul>

                                                <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Form - 16</li>
                                            </ul>

                                            <div className="space20"></div>
                                            <p className="pd-text">Business/Profession:</p>

                                            <ul>
                                                <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Tally data / Audit report / Balance sheet</li>
                                                <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; GST Returns (if any)</li>
                                                <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; TDS Returns (if any)</li>
                                                <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Tax Deposit challan (if any)</li>
                                            </ul>




                                        </ul>

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="single-price border-none">

                                    <div className="price-body">


                                        <h3 className="pd-text">Additionally:</h3>
                                        <div className="sapce30"></div>
                                        <p className="pd-text">If Partnership:</p>
                                        <ul>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Partnership deed / Reconstruction deed / Dissolution deed</li>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Partners PAN card & Aadhaar Card</li>
                                        </ul>

                                        <div className="space40"></div>

                                        <p className="pd-text">If Company & LLP:</p>
                                        <ul>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp;Incorporation Certificate</li>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; MOA</li>
                                            <li><span className="pricing-icon"><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; AOA</li>
                                        </ul>




                                    </div>
                                </div>
                            </div>



                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hadding7">


                                    <h2 className="text-center">Importance of Timely Income Tax E-Filing </h2>

                                </div>
                            </div>
                            <div className="space30"></div>
                            <div className="col-lg-7">
                                <div className="space30"></div>
                                <p className="pd-text">Timely filing of income tax returns is crucial for every taxpayer as it helps avoid penalties and legal consequences. Additionally, complete ITR filing can simplify the process if you need a loan for your business.</p>
                                <p className="pd-text">The ITR filing process offers additional benefits, as the filed document can serve as proof of income. If you need to provide such proof, you can easily use the ITR as verification. By choosing e-filing over traditional methods, you can track the progress of your filing and receive updates until the process is completed.</p>
                                <p className="pd-text">Additionally, filing on time will allow you to carry forward any losses from the current year. Furthermore, it can expedite the visa processing, as it simplifies the documentation required when applying for a visa.</p>
                            </div>

                            <div className="col-lg-5">

                                <div className="contact6-list doc-list">
                                    <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <div className="space40"></div>

                <div className="service-binifits9 sp0 last-section" id="service2" >
                    <div className="space50"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 ">
                                <div className="hadding7">
                                    <h2 className="text-center">Income Tax E-Filing Process Explained</h2>
                                    <div className="space30"></div>
                                    <p className="pd-text">Income tax filing is essential for all taxpayers, whether individuals or business owners. The eligibility for income tax is determined based on an individual's age and gross annual income. To file an income tax return (ITR), both individuals and businesses can use the ITR-3 or ITR-4 forms.</p>
                                </div>

                                <div className="partnership-deade-section">
                                    <div className="space40"></div>





                                    <ul className="disc-list">

                                        <li><h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Once you have submitted your documents, our team will review them thoroughly and notify you if any changes are needed to avoid errors.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Our expert ITR filing team is here to handle all document requirements and ensure the successful completion of your filing.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Our experts will thoroughly review your income and expense details to provide you with personalized advice.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Based on your selected plan, the relevant experts will prepare your Income Tax Return.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                                            <span>Finally, we will file your Income Tax Return on your behalf and provide you with all the relevant deliverables.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                    </ul>

                                    <div className="space80"></div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>



                <div className="tes7 sp2 bg-white">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hadding7">

                                    <h2 className="text-center">Common Mistakes to Avoid in Income Tax E-Filing</h2>

                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="contact6-list doc-list">
                                    <ul>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Incorrect personal details</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Selecting the wrong ITR form</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Failing to report all income sources</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Neglecting eligible deductions and exemptions</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Late filing or non-filing</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Discrepancy in Form 26AS and Income Details</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Not Verifying Before Submission</li>
                                        <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Incomplete Disclosure of Assets</li>


                                    </ul>
                                </div>

                            </div>

                            <div className="col-lg-5">

                                <div className="contact6-list doc-list" >

                                    <div className="space80"></div>
                                    <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                                </div>


                            </div>



                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="faq-items" id="masonry-grid">
                                    <div className="mesonry-item general single-price-list">
                                        <div className="faqs inner-faq">
                                            <h2 className="text-center">FAQs on Income Tax Return </h2>
                                            <div className="space20"></div>


                                            <div id="general">


                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(1)}
                                                    >
                                                        Q1: What does Income Tax E-filing mean?
                                                        <span>
                                                            {activeQuestion === 1 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">Income Tax E-filing is the online process of submitting income tax returns through the official portal, allowing taxpayers to file returns electronically, ensuring a faster and paperless method of compliance.</p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(2)}
                                                    >
                                                        Q2: Who needs to file an Income Tax return?
                                                        <span>
                                                            {activeQuestion === 2 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">Any individual or entity whose income exceeds the exemption limit prescribed by the government must file an Income Tax return. This applies to salaried persons, self-employed individuals, businesses, and others earning taxable income.</p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(3)}
                                                    >
                                                        Q3: Can I file an Income Tax return if my income is below the taxable limit?
                                                        <span>
                                                            {activeQuestion === 3 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">Yes, even if your income is below the taxable limit, you can file an Income Tax return voluntarily. This may be beneficial for claiming refunds or maintaining a record of your financial status.</p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(4)}
                                                    >
                                                        Q4: What happens if I fail to file my Income Tax Return (ITR)?
                                                        <span>
                                                            {activeQuestion === 4 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">Failing to file your Income Tax Return (ITR) on time can result in penalties, interest on unpaid taxes, and possible legal action. The penalty amount depends on how late the filing is and whether there is any tax due.</p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(5)}
                                                    >
                                                        Q5: What are the advantages of filing an Income Tax Return (ITR)?
                                                        <span>
                                                            {activeQuestion === 5 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">Filing an Income Tax Return (ITR) offers several benefits, including easier loan approvals, claiming tax refunds, carrying forward losses, and staying compliant with tax laws. It also helps in maintaining a good financial record.</p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(6)}
                                                    >
                                                        Q6: Is filing an Income Tax Return (ITR) mandatory if I have a PAN card?
                                                        <span>
                                                            {activeQuestion === 6 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">
                                                        Having a PAN card doesn't automatically require you to file an ITR. However, you must file an ITR if your income exceeds the taxable limit, or if you meet other specific criteria set by the Income Tax Department.</p>
                                                    </div>
                                                </div>
                                                <div className="single-faq">
                                                    <h2
                                                        className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                                            }`}
                                                        id="faq-heading1"
                                                        onClick={() => toggleQuestion(7)}
                                                    >
                                                        Q7:Which types of income are exempted from tax?
                                                        <span>
                                                            {activeQuestion === 7 ? (
                                                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                            ) : (
                                                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                            )}
                                                        </span>
                                                    </h2>
                                                    <div
                                                        id="collapse1"
                                                        className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                                            }`}
                                                    >
                                                        <p className="font-f-3 weight-500">Certain types of income are exempt from tax, such as agricultural income, gifts from relatives, certain government bonds, and income up to the prescribed limit under sections like 80C (for savings and investments). Each has specific criteria for exemption.</p>
                                                    </div>
                                                </div>









                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>



                    </div>
                </div>

                <Testimonial />


                <div className="sp2 last-section bg-white">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 ">

                                <div className="hadding7">
                                    <h2 className="text-center">Why Choose Dm2Legal for Income Tax E Filing? </h2>
                                </div>

                            </div>
                        </div>
                        <div className="space30"></div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>1</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="single-service-1.html" >Simple process </a></h4>
                                        <p>With Dm2Legal, users can easily register online by simply providing their name, email ID, contact number, and the required service. This streamlined process makes it convenient for users to sign up and begin using the services.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>2</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Best Online Platform</a></h4>
                                        <p>Dm2Legal's online platform offers easy accessibility from anywhere, providing convenience for clients no matter their location.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>3</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Best Legal Support</a></h4>
                                        <p>The Dm2Legal team offers comprehensive support and assistance to its clients. We provide legal guidance not only after your ITR filing but also value your feedback.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>4</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                                        <p>With over 10 years of experience in the taxation industry, we bring valuable expertise to the table. By choosing us, you'll benefit from working with seasoned tax experts, making the process of filing your Income Tax Return smoother and more efficient.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>5</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >On-time Service</a></h4>
                                        <p>Our team is dedicated to providing timely services without any delays. We understand that delivering services on time demonstrates our respect for our clients' time and commitments.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="service6-box">
                                    <div className="">
                                        <div className="service-box-icon">
                                            <p>6</p>
                                        </div>
                                    </div>
                                    <div className="hadding6">
                                        <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Pocket-friendly Legal Services</a></h4>
                                        <p>Dm2Legal provides cost-effective ITR services, making professional assistance accessible to a wider range of clients. This affordability is a key benefit of choosing our services.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="space40 bg-white"></div>

                <WhatsAppScrollButton />
                <Footer />
                <CircularScrollProgress />

            </div>


        </div>
    );
}
export default Itrfiling;
